import axios from "axios";
import * as actionType from "../../../constant/actionType";
export const GetClientProviderChecklistList = (apiData) => async (dispatch) => {
  /*** API Call Action ***/
  try {
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/provider/GetClientProviderChecklistList`,
      // params: apiData,
      params: {
        ...apiData,
      
        provider_org_ids: JSON.stringify(
          apiData.provider_org_ids?.map((item) => item?.provider_org_id)
        ),
      },
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
};
